import { Address } from 'viem';

import { api, cacheTags, IConnectedActionParams } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';
import { IPoolUnstake } from 'modules/pool/types';

import { getPendingUnstakes } from '../methods/getPendingUnstakes';

export const EMPTY_POOL_UNSTAKES: IPoolUnstake[] = [];

interface IGetLSPendingUnstakesArgs extends IConnectedActionParams {
  poolAddress?: Address;
}

export const {
  useGetLSPendingUnstakesQuery,
  endpoints: { getLSPendingUnstakes: getLSPendingUnstakesEndpoint },
} = api.injectEndpoints({
  endpoints: build => ({
    getLSPendingUnstakes: build.query<
      IPoolUnstake[],
      IGetLSPendingUnstakesArgs
    >({
      queryFn: async ({ poolAddress }) => {
        const client = getPublicClient();
        const walletClient = getWalletClient();

        return {
          data: await getPendingUnstakes(client, {
            accountAddress: asAddress(walletClient.account?.address),
            poolAddress,
          }),
        };
      },
      providesTags: [cacheTags.account, cacheTags.liquidStaking],
    }),
  }),
});
